import { Reducer } from "redux";

import { PatientInformationViewResponse } from "../models/Api/PatientInformation";
import { IntakeStageIdDispatchType } from "../models/DispatchTypes/PatientInformation";
import { IntakeStageIdActionDispatchTypes } from "../constants/PatientInformation";
import { PatientHeaderDefaultValues } from "../constants/Patient";

const initialState: PatientInformationViewResponse = {
  loading: false,
  response: PatientHeaderDefaultValues,
};

const IntakeStageIdReducer: Reducer<
  PatientInformationViewResponse,
  IntakeStageIdDispatchType
> = (state = initialState, action) => {
  switch (action.type) {
    case IntakeStageIdActionDispatchTypes.GET_INTAKE_STAGE_ID_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case IntakeStageIdActionDispatchTypes.GET_INTAKE_STAGE_ID_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case IntakeStageIdActionDispatchTypes.GET_INTAKE_STAGE_ID_RESET: {
      return initialState;
    }
  }
  return state;
};

export default IntakeStageIdReducer;
